import { Directive, TemplateRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[carouselItem]',
    standalone: false
})
export class CarouselItemDirective {
    constructor(public tpl: TemplateRef<any>) {}
}
